
import { computed, getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'
import { login } from '@api/connectors/archimed'
import { CONNECTOR_TYPES } from '@/vars/general'

const TASKS = [
    {
        title: 'Обратитесь в техподдержку ArchiMed',
        body: 'Запросите данные для интеграции с Data Heroes.',
    },
    {
        title: 'Получите Api id и Api secret',
        body: 'Скопируйте значения из ответа поддержки.',
    },
    {
        title: 'Заполните поля справа',
        body: 'После проверки доступов интеграция будет завершена.',
    },
]

export default {
    name: 'ArchimedAuth',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const validLogin = ref<boolean | null>(null)
        const loading = ref(false)
        const creds = ref({
            apiId: '',
            apiSecret: '',
        })

        const btnDisabled = computed(
            () =>
                !String(creds.value.apiId || '').trim() ||
                !String(creds.value.apiSecret || '').trim()
        )

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const submitLogin = async () => {
            loading.value = true
            syncWizardNav()

            const projectId = root.$router.currentRoute.params.id
            const connector = await store.dispatch('project/createConnector', {
                projectId,
                connectorType: CONNECTOR_TYPES.archimed,
            })
            const isLogin = await login(connector, creds.value)
            if (isLogin) {
                store.commit('project/setLoggedAddingConnector', connector)
                root.$parent.$emit('login')
            }
            validLogin.value = isLogin
            loading.value = false
            syncWizardNav()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: !btnDisabled.value,
                nextLoading: loading.value,
                nextLabel: 'Войти',
                onBack: goBackToCrm,
                onNext: submitLogin,
            }),
            [loading, btnDisabled]
        )

        return {
            tasks: TASKS,
            creds,
            validLogin,
            loading,
            btnDisabled,
            hasWizardNav,
            goBackToCrm,
            submitLogin,
        }
    },
}
